webpackJsonp([259619035845468],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _stripIndent = __webpack_require__(59);
	
	var _stripIndent2 = _interopRequireDefault(_stripIndent);
	
	var _Prism = __webpack_require__(90);
	
	var _Prism2 = _interopRequireDefault(_Prism);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Code = function Code(_ref) {
		var _ref$language = _ref.language,
		    language = _ref$language === undefined ? "bash" : _ref$language,
		    code = _ref.code,
		    className = _ref.className,
		    wrapperProps = _objectWithoutProperties(_ref, ["language", "code", "className"]);
	
		return React.createElement(
			_Prism2.default,
			null,
			React.createElement(
				"code",
				_extends({
					className: (0, _classnames2.default)("code-highlight code-highlight--inline", "language-" + language, className)
				}, wrapperProps),
				(0, _stripIndent2.default)(code).trim()
			)
		);
	};
	
	exports.default = Code;
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Code = __webpack_require__(77);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Code2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Code = __webpack_require__(78);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _CodeBlock = __webpack_require__(58);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _Emoji = __webpack_require__(22);
	
	var _Emoji2 = _interopRequireDefault(_Emoji);
	
	var _LayoutContent = __webpack_require__(27);
	
	var _LayoutContent2 = _interopRequireDefault(_LayoutContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var frontmatter = exports.frontmatter = {
		title: "Catch, Recover, and Continue RxJS Streams After An Error",
		description: "RxJS automatically kills streams when errors occur. This is hard coded. The solution: use disposable streams.",
		slug: "/continue-rxjs-streams-when-errors-occur",
		dateCreated: "2017-05-07",
		dateUpdated: "2018-03-19",
		type: "article",
		cover: "./meatballs.jpg",
		shareImage: "./meatballs.jpg"
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var ContentRxjsErrors = function ContentRxjsErrors(props) {
		return React.createElement(
			_LayoutContent2.default,
			{
				currentContent: props.data.currentContent,
				contentListResult: props.data.contentListResult
			},
			React.createElement(Article, null)
		);
	};
	
	exports.default = ContentRxjsErrors;
	
	
	var Article = function Article() {
		return React.createElement(
			"div",
			{ className: "wysiwyg" },
			React.createElement(
				"p",
				null,
				"I assumed RxJS streams worked like Promises, and I was very wrong."
			),
			React.createElement(
				"p",
				null,
				"Here\u2019s a stream of stuff, with meatballs!"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst stuff$ = Rx.Observable.of(\n\t\t\t\t\t'Spaghetti',\n\t\t\t\t\t42,\n\t\t\t\t\t'Meatballs'\n\t\t\t\t);\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Let\u2019s make the stuff lowercase:"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.map(x => x.toLowerCase());\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Quick quiz: what is logged to console?"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tlowercaseStuff$.subscribe(\n\t\t\t\t\t(x => console.log('Success:', x)),\n\t\t\t\t\t(x => console.log('Error:', x)),\n\t\t\t\t\t(() => console.log('Complete'))\n\t\t\t\t);\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"The answer may surprise you:"
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tError: TypeError: x.toLowerCase is not a function\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Where\u2019s the meatballs?! It seems the error killed the stream. Let\u2019s stop that from happening."
			),
			React.createElement(
				"h2",
				null,
				"Attempt #1: Defensive coding"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.map(x => {\n\t\t\t\t\t\tif (typeof x.toLowerCase !== 'function') {\n\t\t\t\t\t\t\treturn undefined;\n\t\t\t\t\t\t}\n\t\t\t\t\t\treturn x.toLowerCase();\n\t\t\t\t\t});\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Result:"
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tSuccess: undefined\n\t\t\t\tSuccess: meatballs\n\t\t\t\tComplete\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Hello meatballs! That was easy!"
			),
			React.createElement(
				"h3",
				null,
				"Hold up\u2026"
			),
			React.createElement(
				"p",
				null,
				"Maybe the \u201Cstream of stuff\u201D is actually a response from a server. You expect to receive nicely structured JSON. Then one day, you don\u2019t."
			),
			React.createElement(
				"p",
				null,
				"Maybe you\u2019re passing the \u201Cstuff\u201D into a 3rd party library, and it throws an error."
			),
			React.createElement(
				"p",
				null,
				"Errors will always happen. You can\u2019t code defensively for every unpredictable possibility."
			),
			React.createElement(
				"p",
				null,
				"Let\u2019s try something else."
			),
			React.createElement(
				"h2",
				null,
				"Attempt #2: Try / catch"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.map(x => {\n\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\treturn x.toLowerCase();\n\t\t\t\t\t\t} catch(error) {\n\t\t\t\t\t\t\treturn undefined;\n\t\t\t\t\t\t}\n\t\t\t\t\t});\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Result:"
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tSuccess: undefined\n\t\t\t\tSuccess: meatballs\n\t\t\t\tComplete\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Meatballs! ",
				React.createElement(
					_Emoji2.default,
					null,
					"\uD83D\uDE0D"
				)
			),
			React.createElement(
				"p",
				null,
				"But, what a nightmare to place this inside ",
				React.createElement(
					"em",
					null,
					"every"
				),
				" operator:"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst moreComplexStuff$ = stuff$\n\t\t\t\t\t.map(x => {\n\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\treturn x.toLowerCase();\n\t\t\t\t\t\t} catch(error) {\n\t\t\t\t\t\t\treturn undefined;\n\t\t\t\t\t\t}\n\t\t\t\t\t})\n\t\t\t\t\t.anotherOperator(x => {\n\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\treturn doSomethingElse(x);\n\t\t\t\t\t\t} catch(error) {\n\t\t\t\t\t\t\treturn undefined;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t});\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"We can do better."
			),
			React.createElement(
				"h2",
				null,
				"Attempt #3: Catch\xA0operator"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.map(x => x.toLowerCase())\n\t\t\t\t\t.catch(error => Rx.Observable.of(error));\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Result:"
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tSuccess: undefined\n\t\t\t\tComplete\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"The error was caught, but the stream completes before the meatballs had a chance."
			),
			React.createElement(
				"p",
				null,
				React.createElement(
					_Emoji2.default,
					null,
					"\uD83E\uDD14"
				),
				" Hmm. The catch operator is returning a bran new stream. Maybe the original stream is completing because it\u2019s replaced?"
			),
			React.createElement(
				"h2",
				null,
				"Attempt #4: Materialize / dematerialize"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.map(x => x.toLowerCase())\n\t\t\t\t\t.materialize()\n\t\t\t\t\t.map(notification => {\n\t\t\t\t\t\tif (notification.kind === \"E\") {\n\t\t\t\t\t\t\treturn Rx.Notification.createNext(undefined);\n\t\t\t\t\t\t}\n\t\t\t\t\t\treturn notification;\n\t\t\t\t\t})\n\t\t\t\t\t.dematerialize();\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"This looks complex, but it\u2019s behaving similar to the catch operator above. We are watching for an error notification, and then converting it into a next / success notification instead."
			),
			React.createElement(
				"p",
				null,
				"It\u2019s pretty low level, but this time we have no catch operator replacing the main stream. Should be fine."
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tSuccess: undefined\n\t\t\t\tComplete\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				React.createElement(
					_Emoji2.default,
					null,
					"\uD83D\uDE16"
				),
				" No meatballs."
			),
			React.createElement(
				"p",
				null,
				"What is going on?!"
			),
			React.createElement("hr", null),
			React.createElement(
				"h2",
				null,
				"Deep in RxJS\xA0Land"
			),
			React.createElement(
				"p",
				null,
				"RxJS is internally wrapping code in operators (like ",
				React.createElement(_Code2.default, { code: "map" }),
				",",
				" ",
				React.createElement(_Code2.default, { code: "filter" }),
				", etc) with a ",
				React.createElement(_Code2.default, { code: "try / catch" }),
				". If an error is caught, it will notify subscribers, and then ",
				React.createElement(
					"strong",
					null,
					"unsubscribe"
				),
				" the stream. This is",
				" ",
				React.createElement(
					"em",
					null,
					"hard coded"
				),
				" \u2014 you have no choice!"
			),
			React.createElement(
				"blockquote",
				{ className: "quote-pull" },
				"If an error is thrown within an operator, the stream will always complete."
			),
			React.createElement(
				"h2",
				null,
				"Solution"
			),
			React.createElement(
				"p",
				null,
				"Create a disposable stream. If an error occurs only the disposable stream dies, and the main stream lives on."
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$\n\t\t\t\t\t.switchMap((x) => {\n\t\t\t\t\t\tconst disposableStream$ = Rx.Observable.of(x);\n\t\t\t\t\t\treturn disposableStream$\n\t\t\t\t\t\t\t.map(x => x.toLowerCase())\n\t\t\t\t\t\t\t.catch(error => Rx.Observable.of(undefined));\n\t\t\t\t\t})\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"Result:"
			),
			React.createElement(_CodeBlock2.default, {
				code: "\n\t\t\t\tSuccess: spaghetti\n\t\t\t\tSuccess: undefined\n\t\t\t\tSuccess: meatballs\n\t\t\t\tComplete\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"We have meatballs! ",
				React.createElement(
					_Emoji2.default,
					null,
					"\uD83D\uDE0B"
				)
			),
			React.createElement(
				"p",
				null,
				"This can be condensed further:"
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tconst lowercaseStuff$ = stuff$.switchMap(x =>\n\t\t\t\t\tRx.Observable.of(x)\n\t\t\t\t\t\t.map(x => x.toLowerCase())\n\t\t\t\t\t\t.catch(error => Rx.Observable.of(undefined))\n\t\t\t\t);\n\t\t\t"
			}),
			React.createElement(
				"p",
				null,
				"And here\u2019s a real world scenario:"
			),
			React.createElement(
				"ul",
				null,
				React.createElement(
					"li",
					null,
					"Processing a response from the server"
				),
				React.createElement(
					"li",
					null,
					"Keeping the main stream alive (so future responses are processed after an error)"
				),
				React.createElement(
					"li",
					null,
					"Performing error handling in the main stream"
				)
			),
			React.createElement(_CodeBlock2.default, {
				language: "js",
				code: "\n\t\t\t\tresponseFromServer$\n\t\t\t\t\t.switchMap(response =>\n\t\t\t\t\t\tRx.Observable.of(response)\n\t\t\t\t\t\t\t.map(response => codeThatMayThrowAnError(response))\n\t\t\t\t\t\t\t.catch(error => Rx.Observable.of(error))\n\t\t\t\t\t)\n\t\t\t\t\t.map(response => {\n\t\t\t\t\t\tif (response instanceof Error) {\n\t\t\t\t\t\t\t// Error handling here\n\t\t\t\t\t\t}\n\t\t\t\t\t\treturn response;\n\t\t\t\t\t});\n\t\t\t"
			})
		);
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-content-blog-2017-rxjs-errors-content-rxjs-errors-js-40ebf6013d928b0fe2c7.js